import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { postUpdateProject } from '../services/postUpdateProject.service';

export const updateProject = createAsyncThunk(
  'projects/updateProject',
  async (projectData, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());
    const projectUpdateData = await postUpdateProject(
      projectData,
      activeEmployerInfo
    );

    return projectUpdateData;
  }
);
